<template>
  <div
    class="data-info-msg"
    :text-msg="translateValues.hasOwnProperty(value) ? $t(translateValues[value]) : 'no translateValues! add it'"
  ></div>
</template>
<script setup>
const translateValues = {
  noNumbers: "general.no_numbers",
  noData: "general.no_data",
  noSip: "telephony.sip.no_data",
  noAccounts: "tiktok.table.no_data",
  loading: "general.loading_msg",
};

defineProps({
  value: {
    type: String, // 'noNumbers', 'loading'
    default: "loading",
  },
  height: {
    type: String,
    default: "320px",
  },
});
</script>

<style lang="scss" scoped>
.data-info-msg {
  position: relative;
  height: v-bind(height);

  * {
    display: none;
  }

  &:after {
    position: absolute;
    display: inline-block;
    content: attr(text-msg);
    top: 50%;
    text-align: center;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    font-size: 24px;
    font-family: "Gilroy";
    font-weight: 500;

    text-transform: uppercase;

    color: lightgrey;
    @media (max-width: 860px) {
      font-size: 1rem;
    }
  }
}
</style>
